import ObjectSetTreeviewModel from "../modelTreeViews/ObjectSetTreeviewModel";
import BaseModel from "./BaseModel";
import BaseObject from "./BaseObject";
import ObjectFactory from "./ObjectFactory";
import ReferenceArray from "./ReferenceArray";

ObjectFactory.registerClass("ObjectSet", (data?: any, parent?: BaseModel) => {
  return new ObjectSet({});
});

// has to do with something of ai
export default class ObjectSet extends BaseModel {
  public get className(): string {
    return "ObjectSet"; // no itx
  }

  constructor(data?: any, parent?: BaseModel) {
    super(data, parent);
    this.treeViewModel = new ObjectSetTreeviewModel(this);
  }


  // -----------------------------------------------------------------------------
  // items
  // -----------------------------------------------------------------------------
  _items = new ReferenceArray<BaseModel>();
  get items(): ReferenceArray<BaseModel> {
    return this._items;
  }

  set items(newValue: ReferenceArray<BaseModel>) {
    if (this._items === newValue) return;
    this.beforeChange("items");
    this._items = newValue;
    this.changed("items");
  }


  // -----------------------------------------------------------------------------
  // gptThreadId
  // -----------------------------------------------------------------------------
  _gptThreadId?: string;
  get gptThreadId(): string | undefined {
    return this._gptThreadId;
  }

  set gptThreadId(newValue: string | undefined) {
    if (this._gptThreadId === newValue) return;
    this.beforeChange("gptThreadId");
    this._gptThreadId = newValue;
    this.changed("gptThreadId");
  } // no itx


  // -----------------------------------------------------------------------------
  // gptRunId
  // -----------------------------------------------------------------------------
  _gptRunId?: string;
  get gptRunId(): string | undefined {
    return this._gptRunId;
  }

  set gptRunId(newValue: string | undefined) {
    if (this._gptRunId === newValue) return;
    this.beforeChange("gptRunId");
    this._gptRunId = newValue;
    this.changed("gptRunId");
  }

  // ----------------------------------------------------------------------------- // no itx

  getPersistentProperties(): string[] {
    return [
      "items", // no itx
      "gptThreadId", // no itx
      "gptRunId", // no itx

      ...super.getPersistentProperties(),
    ];
  }

  add(item: BaseModel): void {
    if (!this.items.add(item)) {
      this.raiseOnChange();
    }
  }

  delete(): Array<BaseObject> {
    this.items.clear();
    return super.delete();
  }

  getAll(): BaseModel[] {
    //
    // todo filter deleted
    //
    const res = this.items.asArray().filter((item) => !item.isDeleted);
    return res;
  }
}
